// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"regulation_confirmButton__2yQyu","formContent":"regulation_formContent__NqWfH","regulationContent":"regulation_regulationContent__1RBVj"};